﻿'use strict';

/**
 * @ngdoc directive
 * @name ntmApp.directive:recurrenceTimePicker
 * @description
 * # recurrenceTimePicker
 */
///////////////////// Directive for time Picker
angular.module('ntmApp').directive('showOnHoverParent',
   function () {
       return {
           link: function (scope, element) {
               element.parent().bind('click', function () {
                   element.show();
               });

               var container = $('.modal-open');

               var onClick = function (e) {

                   if (e.target && !$($(element).parent()[0]).has(e.target).length) {
                       element.hide();
                   }
               };

               container.on('click', onClick);

               scope.$on('$destroy', function () {
                   container.off('click', onClick);
               });
           }
       };
   });
///////////////////////////////////////////////////////////////////////////////

